import { useEffect } from 'react'
import { useMultiVideoUploader } from '@/customHooks/useMultiVideoUploader'
import { Button } from '../atoms'
import { useUserLanguage } from '@/customHooks'
import textsData from '@/textData/ImageUploaderTexts.json'

type VideoUploaderProps = {
  onUploadReady?: (files: File[]) => void
}

export const VideoUploader = ({ onUploadReady }: VideoUploaderProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const {
    handleFileChange,
    previews,
    files,
    isProcessing,
    error,
    reset,
    removeVideo,
  } = useMultiVideoUploader({
    maxSizeMB: 25,
    maxFiles: 5,
    allowedTypes: ['video/mp4'],
  })

  useEffect(() => {
    onUploadReady?.(files)
  }, [files, onUploadReady])

  return (
    <div style={{ padding: '20px', border: '2px dashed #ccc', borderRadius: '8px', marginTop: '1rem' }}>
      <h3>🎥 Subir videos (.mp4)</h3>

      {files.length < 5 && (
        <input
          type="file"
          accept="video/mp4"
          onChange={handleFileChange}
          disabled={isProcessing}
          multiple
        />
      )}

      {files.length > 0 && (
        <p>
          {files.length} de 5 videos cargados.
        </p>
      )}

      {isProcessing && <p>{texts.compressingImages}</p>}

      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          ❌ {error}
        </div>
      )}

      {previews.length > 0 && (
        <>
          <div style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            <h4>Vistas previas:</h4>
            {previews.map((preview, index) => {
              const file = files[index]
              return (
                <div
                  key={preview.id}
                  style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', maxWidth: '260px' }}
                >
                  <video
                    src={preview.url}
                    controls
                    style={{
                      maxWidth: '100%',
                      maxHeight: '150px',
                      borderRadius: '4px',
                    }}
                  />
                  <div style={{ marginTop: '10px', fontSize: '12px' }}>
                    <p style={{ margin: 0, wordBreak: 'break-all' }}>
                      <strong>{texts.fileNameLabel}</strong> {file?.name}
                    </p>
                    <p style={{ margin: '5px 0' }}>
                      <strong>{texts.fileSizeLabel}</strong>{' '}
                      {file
                        ? (file.size / (1024 * 1024)).toFixed(2) + ' MB'
                        : 'N/A'}
                    </p>
                    <Button onClick={() => removeVideo(index)} secondary>
                      {texts.deleteButton}
                    </Button>
                  </div>
                </div>
              )
            })}
          </div>
          {files.length > 0 && (
            <Button onClick={reset} secondary>
              Limpiar todo
            </Button>
          )}
        </>
      )}
    </div>
  )
}

